module.exports = __webpack_public_path__ + "8e0dba6bcefa3d345df794cde708869c.jpg";